import * as React from 'react';
import { FC, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ToolBar from './ToolBar';
import WeeklyPacksPerRegion from './WeeklyPacksPerRegion';
import MonthlyPacksPerRegion from './MonthlyPacksPerRegion';
import WeeklyQuantitiesPerRegion from './WeeklyQuantitiesPerRegion';
import MonthlyQuantitiesPerRegion from './MonthlyQuantitiesPerRegion';
import { Customer, Order, Review } from '../../types';
interface Region {
    id: string;
    name: string;
}

interface CustomerData {
    [key: string]: Customer;
}

interface State {
    nbNewOrders?: number;
    nbPendingReviews?: number;
    pendingOrders?: Order[];
    pendingOrdersCustomers?: CustomerData;
    pendingReviews?: Review[];
    pendingReviewsCustomers?: CustomerData;
    recentOrders?: Order[];
    revenue?: number;
}

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '0em',
        // backgroundColor: 'red',
    },
    flex: { display: 'flex' },
    flexColumn: {
        display: 'flex',
        marginBottom: '0em',
        // backgroundColor: 'red',
    },
    leftCol: { flex: 1, marginRight: '0em' },
    rightCol: { flex: 1, marginLeft: '0em' },
    kpiContainer: { padding: '1em' },
    // singleCol: { marginTop: '0.5em', marginBottom: '0.5em' },
}));

// const Spacer = () => <span style={{ width: '1em' }} />;
// const VerticalSpacer = () => <span style={{ height: '1em' }} />;

const RegionDashboard: FC<any> = ({ lastyear = false }) => {
    const [region, setRegion] = useState('all');

    const classes = useStyles();

    return (
        <div className={classes.container}>
            {/* <div className={classes.flexColumn}>
                <div className={classes.leftCol}>
                    <div className={classes.kpiContainer}>
                        <ToolBar setRegion={setRegion} />
                    </div>
                </div>
                <div className={classes.rightCol}></div>
            </div> */}
            <div className={classes.flexColumn}>
                {/* <div className={classes.leftCol}>
                    <div className={classes.kpiContainer}>
                        <WeeklyPacksPerRegion region={region} height={200} />
                    </div>
                    <div className={classes.kpiContainer}>
                        <WeeklyQuantitiesPerRegion
                            region={region}
                            height={200}
                        />
                    </div>
                </div> */}
                <div className={classes.rightCol}>
                    {/* <div className={classes.kpiContainer}>
                        <MonthlyPacksPerRegion region={region} height={250} />
                    </div> */}
                    <div className={classes.kpiContainer}>
                        <MonthlyQuantitiesPerRegion
                            lastyear={lastyear}
                            region={region}
                            height={250}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RegionDashboard;
